import * as React from "react";
import useSWR from "swr";
import { useDispatch } from "../globalState";
import { actionCreators } from "../reducer";
import getCookie from "../util/getCookie";
import fetcher from "./fetcher";
import { IDENTITY_KEY } from "./identityKey";

const SIGNED_OUT = {};
const UNAUTHORIZED = 401;

export default function useIdentity() {
  const dispatch = useDispatch();
  const key = getCookie("ut") ? IDENTITY_KEY : null;
  const { data, error } = useSWR(key, fetcher, { revalidateOnFocus: true });
  const signedOut = !key || error?.status === UNAUTHORIZED;
  const user = signedOut ? SIGNED_OUT : data?.data;

  React.useEffect(() => {
    if (user) dispatch(actionCreators.createSetUser(user));
  }, [user, dispatch]);
}
